export const LOGIN = "LOGIN";
export const RESET_LOGIN = "RESET_LOGIN";
export const LOADING = "LOADING";
export const IS_OPEN_MODAL_PICTURE = "IS_OPEN_MODAL_PICTURE";
//props
export const GET_PROPS = "GET_PROPS";
export const GET_PROPIEDAD = "GET_PROPIEDAD";
export const ELIMINA_PROP = "ELIMINA_PROP";
export const ACTUALIZA_PROP = "ACTUALIZA_PROP";
export const RESET_PROPERTY = "RESET_PROPERTY";
export const MUESTRA_DESTACADAS = "MUESTRA_DESTACADAS";
export const RESET_PROPS = "RESET_PROPS";
//ususarios
export const CREA_USUARIO = "CREA_USUARIO";
export const GET_USUARIOS = "GET_USUARIOS";
export const GET_USUARIO = "GET_USUARIO";
export const MODIFICA_USUARIO = "MODIFICA_USUARIO";
export const ELIMINA_USUARIO = "ELIMINA_USUARIO";